import {
  Box
} from "@mui/material";
import styled from "styled-components";

export const StyledTabTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.white.main,
  fontWeight: 'bold',
  fontSize: '16px',
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1),
  textTransform: 'capitalize',
  
}))